import React from "react";
import { Stack } from "@mui/material";
import {
  TextInputField,
  useSpacing,
} from "@surya-digital/leo-reactjs-material-ui";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import {
  useEmailTemplatesStore,
  useUpdateEmailTemplateStore,
} from "../../stores/Hooks";
import { getEmailTemplateValidationErrorMessage } from "../../utils/getEmailTemplateValidationErrorMessage";
import { CampaignEmailPlaceholderPicker } from "../inputs/CampaignEmailPlaceholderPicker";
import { EmailTemplateContentRTE } from "../inputs/EmailTemplateContentRTE";
import { useSearchParams } from "react-router-dom";
import { RouteSearchParam } from "../../../../routes/RoutesHelper";

const TEMPLATE_FIELD_WIDTH = "600px";

export const UpdateEmailTemplateForm: React.FC = observer(() => {
  const { t } = useTranslation();
  const spacing = useSpacing();
  const updateEmailTemplateStore = useUpdateEmailTemplateStore();
  const emailTemplatesStore = useEmailTemplatesStore();
  const [searchParams] = useSearchParams();

  const validationErrors = getEmailTemplateValidationErrorMessage(t, {
    name: updateEmailTemplateStore.emailTemplateName.validationError,
    content: updateEmailTemplateStore.emailTemplateContent.validationError,
  });
  const selectedTemplateId = searchParams.get(RouteSearchParam.TemplateId);
  const selectedTemplate = selectedTemplateId
    ? emailTemplatesStore.emailTemplates.find(
        (template) => template.id === selectedTemplateId,
      )
    : undefined;

  return (
    <Stack gap={spacing.spaceLG}>
      <Stack width="100%" maxWidth={TEMPLATE_FIELD_WIDTH}>
        <TextInputField
          name="template"
          label={t("emailTemplates.titleLabel")}
          value={updateEmailTemplateStore.emailTemplateName.name}
          type="text"
          onTextChange={(value) =>
            updateEmailTemplateStore.emailTemplateName.setName(value)
          }
          placeholder={t("emailTemplates.titlePlaceholder")}
          error={!!validationErrors.name}
          helperText={validationErrors.name}
          required
        />
      </Stack>
      {selectedTemplate && (
        <Stack width="100%" maxWidth={TEMPLATE_FIELD_WIDTH}>
          <CampaignEmailPlaceholderPicker
            projectId={selectedTemplate.projectId ?? null}
          />
        </Stack>
      )}
      <EmailTemplateContentRTE
        mode="editable"
        initialValue={updateEmailTemplateStore.emailTemplateContent.content}
        onChange={(value) =>
          updateEmailTemplateStore.emailTemplateContent.setContent(value)
        }
        error={!!validationErrors.content}
        helperText={validationErrors.content}
        rteFileService={
          updateEmailTemplateStore.emailTemplateContent.rteFileService
        }
        enableRTEPopupZIndexFix
      />
    </Stack>
  );
});
